import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _configurationRequest = {};
var _configurationResponse = {};
var _generateImageRequest = {};
var _generateImageResponse = {};
var _resetQuotaRequest = {};
var _resetQuotaResponse = {};
var _setUserQuotaRequest = {};
var _setUserQuotaResponse = {};
function resolveComWixMediaGenerationV1MediaGenerationServiceUrl(opts) {
    var domainToMappings = {
        'manage._base_domain_': [
            {
                srcPath: '/_api/media-generation-server',
                destPath: '',
            },
        ],
        'apps._base_domain_': [
            {
                srcPath: '/_api/media-generation-server',
                destPath: '',
            },
            {
                srcPath: '/_api/media-generation-server',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/**
 * Generate images according to the specified prompt
 * Due to provider limitations, we may need to switch between providers.
 * This means that the result size of the image (width and height) may not be the same as the requested size
 * This method will always try to find the closest size that the AI provider allows
 * @deprecated Will be removed on 2024-11-01.
 */
export function generateImage(payload) {
    var _a = serializer(_generateImageRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_generateImageResponse, {}).fromJSON;
    function __generateImage(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.media.generation.v1.generated_image',
            method: 'POST',
            methodFqn: 'com.wix.media.generation.v1.MediaGenerationService.GenerateImage',
            url: resolveComWixMediaGenerationV1MediaGenerationServiceUrl({
                protoPath: '/v1/image/generate',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __generateImage.fromReq = fromReq;
    __generateImage.__isAmbassador = true;
    return __generateImage;
}
/** Return service level configurations to the client for dropdown fields content */
export function configuration(payload) {
    var _a = serializer(_configurationRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_configurationResponse, {}).fromJSON;
    function __configuration(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.media.generation.v1.generated_image',
            method: 'GET',
            methodFqn: 'com.wix.media.generation.v1.MediaGenerationService.Configuration',
            url: resolveComWixMediaGenerationV1MediaGenerationServiceUrl({
                protoPath: '/v1/configuration',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __configuration.fromReq = fromReq;
    __configuration.__isAmbassador = true;
    return __configuration;
}
/** Return quota record for a site */
export function setUserQuota(payload) {
    var _a = serializer(_setUserQuotaRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_setUserQuotaResponse, {}).fromJSON;
    function __setUserQuota(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.media.generation.v1.generated_image',
            method: 'POST',
            methodFqn: 'com.wix.media.generation.v1.MediaGenerationService.SetUserQuota',
            url: resolveComWixMediaGenerationV1MediaGenerationServiceUrl({
                protoPath: '/v1/user/quota',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __setUserQuota.fromReq = fromReq;
    __setUserQuota.__isAmbassador = true;
    return __setUserQuota;
}
/** only allowed for specific users, resets the quota for all users */
export function resetQuota(payload) {
    var _a = serializer(_resetQuotaRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_resetQuotaResponse, {}).fromJSON;
    function __resetQuota(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.media.generation.v1.generated_image',
            method: 'POST',
            methodFqn: 'com.wix.media.generation.v1.MediaGenerationService.ResetQuota',
            url: resolveComWixMediaGenerationV1MediaGenerationServiceUrl({
                protoPath: '/v1/bo/quota/reset-all',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __resetQuota.fromReq = fromReq;
    __resetQuota.__isAmbassador = true;
    return __resetQuota;
}
//# sourceMappingURL=http.impl.js.map